import ReactDOM from 'react-dom';
import { Locations } from './LocationFinderResults';
import { RegionalService } from '../../reactcomponents/services/regional/RegionalService';

const INPUT_DEBOUNCE_MILLISECONDS = 1000;
const ZIPCODE_MINIMUM_LENGTH = 3;

export function initLocationFinder() {

  const triggerLookup = (event: Event) => doLookup(event);
  const triggerDebouncedLookup = debounce((event: Event) => doLookup(event));

  async function doLookup(event: Event) {

    let sender = event.target;
    let container;

    if (!(sender instanceof HTMLInputElement)) {
      let button = sender as HTMLButtonElement;
      container = button.closest(".location-searcher-enabled");
      sender = container.getElementsByClassName("location-searcher")[0];
    }

    const inputTarget = sender as HTMLInputElement;
    container = inputTarget.closest(".location-searcher-enabled");

    const zipcodeValue = inputTarget.value;
    const domContainer = document.getElementById('mylocations_' + container.dataset.widgetid);

    ReactDOM.render(null, domContainer);

    if (zipcodeValue.trim().length < ZIPCODE_MINIMUM_LENGTH) {
      return;
    }

    const spinner = container.getElementsByClassName("spinning-icon")[0] as HTMLElement;
    spinner.classList.remove('d-none');

    if (domContainer) {
      var result = await RegionalService.getLocations(zipcodeValue);
      ReactDOM.render(Locations(result, container.dataset.widgetid), domContainer);
    }

    spinner.classList.add('d-none');
  }

  function debounce(func: Function, timeout = INPUT_DEBOUNCE_MILLISECONDS) {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  const content = document.getElementsByClassName("location-searcher-enabled")[0];
  const inputs = Array.from(content.getElementsByClassName('location-searcher'));
  const buttons = Array.from(content.querySelectorAll('button'));

  inputs.forEach(inpt => {
    inpt.addEventListener('input', (event) => {

      triggerDebouncedLookup(event);

    });
    return;
  });

  buttons.forEach(btn => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();

      triggerLookup(event);

    });
    return;
  });

}